import { Navigate, Route, Routes } from 'react-router-dom'
import { useEffect } from 'react'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { AppBottomNav } from '@/components/layout/AppBottomNav'
import { AppHeader } from '@/components/layout/AppHeader'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { CatalogPage } from '@/pages/CatalogPage'
import { ChatWorkspacePage } from '@/pages/ChatWorkspacePage'
import { ComparePage } from '@/pages/ComparePage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ScanHistoryPage } from '@/pages/ScanHistoryPage'
import { LoginPage } from '@/pages/LoginPage'
import { SessionsPage } from '@/pages/SessionsPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { useAppNavMode } from '@/hooks/useDeviceLayout'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/authStore'

function AppShell() {
  const navMode = useAppNavMode()
  const isPhoneLandscape = useMediaQuery('(max-width: 767px) and (orientation: landscape)')
  const { user, logout } = useAuthStore()

  const showSidebar = navMode === 'sidebar' || navMode === 'sidebar-compact'
  const showBottomNav = navMode === 'bottom'

  return (
    <div className="flex h-full min-h-0" data-testid="app-shell">
      {showSidebar ? <AppSidebar mode={navMode} /> : null}

      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <AppHeader
          userDisplayName={user?.displayName}
          onLogout={() => void logout()}
          showBrand={!showSidebar}
        />

        <main
          className={cn(
            'min-h-0 flex-1 overflow-hidden',
            showBottomNav && 'pb-[calc(3.5rem+env(safe-area-inset-bottom))]',
          )}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/scans" element={<ScanHistoryPage />} />
            <Route path="/scans/:scanId" element={<ScanHistoryPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/chat" element={<ChatWorkspacePage />} />
            <Route path="/compare/:batchId" element={<ComparePage />} />
            <Route path="/sessions" element={<SessionsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </main>

        {showBottomNav ? <AppBottomNav compact={isPhoneLandscape} /> : null}
      </div>
    </div>
  )
}

export default function App() {
  const checkSession = useAuthStore((state) => state.checkSession)

  useEffect(() => {
    void checkSession()
  }, [checkSession])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/*" element={<AppShell />} />
      </Route>
    </Routes>
  )
}
